import angular from 'angular';
import { cloneDeep } from 'lodash';
import '../services/place';
import '../services/videos';
import '../services/errors';
import './modals/videos';

const module = angular.module('whyline.controllers.videos', [
  'whyline.services.place',
  'whyline.services.videos',
  'whyline.services.errors',
  'whyline.modals.videos',
]);

const VideosController = ($scope, $uibModal, $window, $translate, PlaceService, VideosService, NotificationService, ErrorService, dialog, $state, $timeout) => {
  'ngInject';
  $scope.quantityOfItems = 8;

  PlaceService.GetCurrentAsPromise()
    .then(place => {
      $timeout(() => {
        $scope.currentPlace = place;
      });
    })
    .catch(ErrorService.handler);

  $scope.remove = video => {
    // @TODO traducir
    dialog.confirm(`¿Seguro queres borrar el video ${video.name}?`)
      .then(() => {
        VideosService.Remove(video._id, $state.params.placeId);
        NotificationService.Success($translate.instant('video_remove_succ'));
      })
      .catch(ErrorService.handler);
  };

  // Modal
  $scope.open = video => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/video-modal.html',
      size: 'lg',
      controller: 'VideosModalController',
      resolve: {
        placeId: () => $state.params.placeId,
        currentVideo: () => cloneDeep(video),
      }
    });
  };
};

module.exports = module.controller('VideosController', VideosController);
